import { z } from 'zod';

export const worldlineConfigSchema = z.object({
  restaurantId: z.string(),
  merchantId: z.string(),
  apiKey: z.string(),
  apiSecret: z.string(),
  webhookKey: z.string(),
  webhookSecret: z.string(),
  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type WorldlineConfig = z.output<typeof worldlineConfigSchema>;

/** Strict schema */
export const worldlineConfigStrictSchema = worldlineConfigSchema;

export const worldlineConfigCvxSchema = worldlineConfigSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type WorldlineConfigCvx = z.output<typeof worldlineConfigCvxSchema>;

/** Public variant that omits write-only secrets (apiSecret, webhookSecret). */
export const worldlineConfigPublicCvxSchema = worldlineConfigCvxSchema.omit({
  apiSecret: true,
  webhookSecret: true,
});
export type WorldlineConfigPublicCvx = z.output<typeof worldlineConfigPublicCvxSchema>;
